export default {
    clientId: 'dikanong',
    name: '迪卡侬',
    env: 'production',
    api: {
      baseUrl: 'https://api.zhenhan.com',
      host: 'https://tcd.chunhon-info.com/'
    },
    auth: {
      appid: "unPUbmZ_zJYe2B-7Hkf4XK6fK3x9TmkacLdkOL2Mlj0=",
      app_secret: "3wcA_UXM-tge2GucpLULJ5s0oX4feMSiiHTWEjy5ybM=",
      corp_id: "ww36ba8f38931cf88c"
    },
    clientConfig: {
      contact_person_tab_list: [
        { title: "联系人" },
        { title: "企微好友" },
        { title: "企业通讯录" }
      ]
    },
    theme: {
      primaryColor: '#409EFF',
      elementColor: '#409EFF'
    },
    i18n: {
      locale: 'zh-CN',
      fallbackLocale: 'en-US'
    },
    build: {
      publicPath: '/h5/',
      pmEnabled: true,
      version: '1.0.0',
      sourceLink: false,
      buildMode: 'PREVIEW'
    },
    allowedUsers: ['HuangQiongYao', 'wangyanhui']
  }